import {fetch} from "utils/dataAccess";

export function listExpeditionList(inventoryId) {
    return new Promise ((resolve, reject) => {
        fetch('/expedition_lists?inventoryId='+inventoryId, {})
            .then((response) => {
                response.json().then(retrieved => {
                    resolve(retrieved["hydra:member"])
                })
            })
            .catch(error => reject(error))
    })
}